import { cn } from "../../lib/utils"

export function PageHeader({
  title,
  subtitle,
  actions,
  className,
  ...props
}) {
  return (
    <div className={cn("mb-6 md:mb-8", className)} {...props}>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-1">
          <h1 className="text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
            {title}
          </h1>
          {subtitle && (
            <p className="text-muted-foreground text-sm sm:text-base">
              {subtitle}
            </p>
          )}
        </div>
        {actions && (
          <div className="flex items-center gap-2 mt-2 sm:mt-0">
            {actions}
          </div>
        )}
      </div>
      <hr className="mt-4 border-border" />
    </div>
  )
}
